import { TipoProduto } from 'src/app/core/enums/produto.enum';
import { DefaultFilter } from 'src/app/core/framework/default-service.interface';
import { DefaultModel } from 'src/app/core/framework/default.model';
import { Unidade } from '../../unidade/unidade.model';
import { LoteComInventarioDTO } from 'src/app/sala-de-medicacao/medicacao-lote/componentes/seletor-de-lote/seletor-de-lote/dto/lote-com-inventario-dto.model';
import { LoteInventarioDTO } from './lote-inventario-dto.model';
import { DateTimeUtil } from 'src/app/core/framework/utils/date-time-util';
import { deprecate } from 'util';


export interface ILoteFilter extends DefaultFilter {

    statusUnidade?: string;

    id?: number;

    idInventario?: number;

    idProduto?: number;

    descricao?: string;

    quantidadeMaiorQue?: number;

    dataVencimentoDe?: string;

    dataVencimentoPara?: string;

}

export class Lote extends DefaultModel {
  unidade: Unidade;
  produto: {
      id: number
      , tipo: TipoProduto
      , codigo?: string
      , descricao: string
      , status: string
  };
  descricao: string;
  quantidade: number;
  quantidadeTotal?: number;
  dataVencimento: Date;
  valor: number;

  clear?() {
    // nao limpar a unidade aqui
    this.descricao = null;
    this.produto = null;
    this.quantidade = null;
    this.dataVencimento = null;
    this.valor = null;
  }

  // public static parseToLoteInventarioDTO(lote: Lote): LoteInventarioDTO {
  //   const dateTimeUtil = new DateTimeUtil();

  //   const o: LoteInventarioDTO = {
  //     origem: (lote.id)
  //     idLote: lote.id,
  //     idUnidade: lote.unidade?.id,
  //     nomeUnidade: lote.unidade?.nome,



  //     produto: lote.produto,
  //     descricao: lote.descricao,
  //     quantidade: lote.quantidade,
  //     quantidadeTotal: lote.quantidadeTotal,
  //     dataVencimento: dateTimeUtil.dateToIsoFormat(lote.dataVencimento),
  //     valor: lote.valor,
  //     idItemInventario: null,
  //     inventario: null
  //   }

  //   return o;
  // }

/**
 * @deprecated
 * Utilizar parseToLoteInventarioDTO
 */
  public static parseToLoteComInventarioDTO(lote: Lote): LoteComInventarioDTO {
    const loteComInventarioDTO: LoteComInventarioDTO = {
      id: lote.id,
      status: lote.status,
      unidade: lote.unidade,
      produto: lote.produto,
      descricao: lote.descricao,
      quantidade: lote.quantidade,
      quantidadeTotal: lote.quantidadeTotal,
      dataVencimento: lote.dataVencimento,
      valor: lote.valor,
      idItemInventario: null,
      inventario: null
    }

    return loteComInventarioDTO;
  }
}
